import { toLogin } from './index.js'
// import router from '@/router'

export function sortChange(column, cb) {
    if (!toLogin()) return
    let sort = ''
    if (column.order == 'ascending') {
        sort = 'asc'
    } else if (column.order == 'descending') {
        sort = 'desc'
    } else {
        sort = ''
    }
    // 有多列排序时会用到
    // if (column.prop == "publishTime") {
    //     this.key = "publish_time ";
    // }  else if (column.prop == "updateTime") {
    //     this.key = "update_time";
    // } else {
    //     this.key = "";
    // }
    const key = 'sort[' + column.prop + ']'
    if (column.prop) {
        cb({ [key]: sort })
    } else {
        cb()
    }
}
